import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Accounts } from "@tae/interfaces";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { AccountsListComponent } from "../accounts-list/accounts-list.component";
import {
  PageViewInferface,
  SetEventInterface,
} from "src/app/interfaces/tagging.interface";
import { TaggingService } from "../../services/tagging.service";
import { StorageService } from "@tae/services";

@Component({
    selector: "app-select-account",
    templateUrl: "./select-account.component.html",
    styleUrls: ["./select-account.component.scss"],
    standalone: false
})
export class SelectAccountComponent {
  /**
   * Titulo de la tarjeta
   */
  @Input() title: string;

  /**
   * Cuenta seleccionada
   */
  @Input() account: Accounts;

  /**
   * Cuentas recibidas
   */
  @Input() accounts: Accounts[] = [];

  /**
   * Emite la cuenta seleccionada en el dialogo
   */
  @Output() OnAccountSelected: EventEmitter<any> = new EventEmitter();

  constructor(
    private bss: BottomSheetService,
    private taggingService: TaggingService
  ) {}

  public openAccountList() {
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "detalle",
      etiqueta: "cuenta",
      canalBanco: "supermovil",
      url: "recarga_celular/detalle",
      userID: "",
    };

    this.taggingService.setEvent(action);

    const config = {
      title: this.title,
      closeLabel: "Cancelar",
    };
    if (this.accounts?.length > 1) {
      this.bss.show(AccountsListComponent, {
        accounts: this.accounts,
        title: this.title,
        selected: (account: Accounts) => this.onSelected(account),
        config: config,
      });
    }
  }

  /**
   * Emite la cuenta selecciona por el usuario
   * @param { Accounts } account
   * @returns void
   */
  public onSelected(account: Accounts): void {
    this.OnAccountSelected.emit(account);
    this.bss.hide();
  }
  /**
   * Regresa la infromación de la tarjeta enmascarada
   * @param { Accounts } _account
   * @returns { string } información de la tarjeta enmascarada
   */
  public buildDetailAccount(_account: Accounts): string {
    const { cardType, cardNumber } = _account.card;
    const { accountNumber } = _account.account;
    if (cardType === "TDC") {
      return `${cardType} ${cardNumber.slice(0, 4)}**${cardNumber.slice(-4)}`;
    }
    return `CTA ${accountNumber.slice(0, 2)}**${accountNumber.slice(-4)}`;
  }
}
